import { legacy_createStore as createStore} from 'redux'
import rootReducer from './reducers/'
import {Provider} from 'react-redux'

const store = createStore(
    rootReducer,
    window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__()
)
export const DataProvider = ({ children }) => {
        return (
        <Provider store={store}>
            { children  }
        </Provider>
    )
}


